import React from 'react'
import { useAppHeaderLoadingIndicatorStyles } from './app-header-loading-indicator.styles'

export const AppHeaderLoadingIndicator: React.FC = (): React.ReactElement => {
  const classes = useAppHeaderLoadingIndicatorStyles()
  return <div className={classes.loadingStatus} />
}
